import React, { useState } from 'react'
import Modal from 'react-modal'
import classNames from 'classnames'
import PropTypes from 'prop-types'
import exact from 'prop-types-exact'
import '../../styles/modal.pcss'
import useWindowSize from '../../hooks/useWindowSize'

export default function GenericModal({
  modalId,
  title,
  children,
  okButtonTxt,
  cancelButtonTxt,
  requireUserInput = true,
  onClose,
  onOkClick,
  onCancelClick,
  okClickCloses = true,
  cancelClickCloses = true,
}) {
  const [isOpen, setIsOpen] = useState(true)
  const [contentNode, setContentNode] = useState(null)
  const { height: windowHeight } = useWindowSize()
  const alignToTop = contentNode ? windowHeight < contentNode.clientHeight + 100 : false

  const handleCloseRequest = () => {
    if (!requireUserInput) {
      setIsOpen(false)
      onClose(modalId)
    }
  }

  const handleOkClick = () => {
    if (okClickCloses) {
      setIsOpen(false)
      onClose(modalId)
    }
    onOkClick?.()
  }

  const handleCancelClick = () => {
    if (cancelClickCloses) {
      setIsOpen(false)
      onClose(modalId)
    }
    onCancelClick?.()
  }

  return (
    <Modal
      isOpen={ isOpen }
      onRequestClose={ handleCloseRequest }
      contentLabel='Modal'
      contentRef={ setContentNode }
      className={ {
        base: classNames('reactModal', modalId),
        afterOpen: 'afterOpen',
        beforeClose: 'beforeClose',
      } }
      overlayClassName={ {
        base: classNames(
          'reactModalOverlay', modalId, { 'alignToTop': alignToTop }
        ),
        afterOpen: 'afterOpen',
        beforeClose: 'beforeClose',
      } }
    >
      { !requireUserInput && (
        <button type='button' onClick={ handleCloseRequest } className='close-button'>
          <span className='fa fa-close' />
          <span className='sr-only'>Sulje ponnahdusikkuna</span>
        </button>
      ) }
      { title && <h1 className='modal-title'>{ title }</h1> }
      { children && <div className='modal-content'>{ children }</div> }
      { (okButtonTxt || cancelButtonTxt) &&
        <ul className='buttons'>
          { okButtonTxt &&
            <li><button type='button' className='button button_full-width positive' onClick={ handleOkClick }>{ okButtonTxt }</button></li>
          }
          { cancelButtonTxt &&
            <li><button type='button' className='button button_full-width negative' onClick={ handleCancelClick }>{ cancelButtonTxt }</button></li>
          }
        </ul>
      }
    </Modal>
  )
}


GenericModal.propTypes = exact({
  modalId: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.node,
  okButtonTxt: PropTypes.string,
  cancelButtonTxt: PropTypes.string,
  requireUserInput: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onOkClick: PropTypes.func,
  onCancelClick: PropTypes.func,
  okClickCloses: PropTypes.bool,
  cancelClickCloses: PropTypes.bool,
})
